import type { PricingTableCurrency } from '@getaccept/editor-lib';
import { EPricingTableCurrencyDisplay, allCurrencies } from '@getaccept/editor-lib';
import type { Entity } from '../types/entity';

export class CurrencyHelper {
  static getCurrencies(): PricingTableCurrency[] {
    return allCurrencies.map((currency: PricingTableCurrency) => ({
      ...currency,
      labelWithFlag: `${currency.flag} ${currency.customName || currency.currencyCode} - ${
        currency.label
      }`,
      key: `${currency.locale}${currency.currencyCode}`,
    }));
  }

  static getLocaleFromCountryCode(currencies: PricingTableCurrency[], countryCode: string): string {
    const filteredCurrenciesByCountryCode = currencies.filter(
      currency => this.getCountryCodeFromLocale(currency.locale) === countryCode
    );
    return filteredCurrenciesByCountryCode.length
      ? filteredCurrenciesByCountryCode[0].locale
      : currencies[0].locale;
  }

  static getCountryCodeFromLocale(locale: string): string {
    return locale.slice(-2);
  }

  static getDefaultCurrencySettings(entity: Entity) {
    let currency = 'USD';
    let locale = 'en-US';
    if (entity) {
      const { currency: entityCurrency, countryCode } = entity;
      const filteredCurrenciesByEntityCurrency = allCurrencies.filter(
        ({ currencyCode }) => currencyCode === entityCurrency
      );
      currency = !filteredCurrenciesByEntityCurrency.length
        ? currency
        : filteredCurrenciesByEntityCurrency[0].currencyCode;
      locale = !filteredCurrenciesByEntityCurrency.length
        ? locale
        : CurrencyHelper.getLocaleFromCountryCode(filteredCurrenciesByEntityCurrency, countryCode);
    }
    return {
      formatOptions: {
        currency,
        currencyDisplay: EPricingTableCurrencyDisplay.Symbol,
      },
      locale,
    };
  }
}
